module.exports = __webpack_public_path__ + "static/media/Cover-works.06ff6cd9.jpg";